import videoSourceTypes from 'helpers/enums/interactiveVideo/videoSourceTypes'

export default {
	[videoSourceTypes.AMAZON]: 'Uploaded Video',
	[videoSourceTypes.YOUTUBE]: 'YouTube',
}
